import { fetchWithAuthToken } from "../../axios";
import { getMunicipalityFeatures } from "../../js/geojsonAPI";
import { showError } from "../../js/ui-helpers";


export const state = () => ({
    plan: null,
    municipalityFeature: null,
    results: {
        bat: null,
        sst: null,
        mhp: null,
    }
});

export const getters = {
    getPlan: state => state.plan,
    hasPlan: state => Boolean(state.plan),
    getMunicipalityFeature: state => state.municipalityFeature,
    getSstResults: state => state.results.sst,
    getMhpResults: state => state.results.mhp,
    getBatResults: state => state.results.bat,
    showBatResults: (state, getters) => Boolean(getters.getBatResults),
    showMhpResults: (state, getters) => Boolean(getters.getMhpResults),
    showSstResults: (state, getters) => Boolean(getters.getSstResults),
    showResults: (state, getters) => getters.showBatResults || getters.showMhpResults || getters.showSstResults,
};

export const actions = {
    setPlanCompleted({commit}, isCompleted)
    {
        commit('SET_PLAN_COMPLETED', isCompleted);
    },
    async setPlan({commit}, plan)
    {
        commit('SET_PLAN', plan);
        const sddmm = plan && plan.municipality && plan.municipality.sddmm;
        getMunicipalityFeatures()
        .then(features => features.find(ftr => ftr.get('SDDMM')===sddmm))
        .then(municipalityFeature => commit('SET_MUNICIPALITY', municipalityFeature));
        
    },
    async fetchPlan({dispatch}, planId)
    {
        try
        {
            const {data: plan} = await fetchWithAuthToken(`api/plan/${planId}`, {});
            dispatch('setPlan', plan);
            dispatch('layers/updatePlanLayersFeatures', planId, {root: true});
            return plan;
        }
        catch (error)
        {
            if (error.response && error.response.status===404)
            {
                showError('Plan', "Plan not found");
                return;
            }
            showError('Plan', 'Failed loading plan');
        }
    },
    clearPlan({commit, dispatch})
    {
        commit('SET_PLAN', null);
        dispatch('layers/clearPlanLayers', null, {root: true});
    },
    async fetchSSTProject(_, {plan_id})
    {
        console.assert(plan_id, "plan id no defined")
        const response = await fetchWithAuthToken(`api/sst/${plan_id}`);
        return response.data;
    },
    setSstResultsToShow({commit}, result)
    {
        commit('SET_SST_RESULTS', result);
    },
    setMhpResultsToShow({commit}, result)
    {
        commit('SET_MHP_RESULTS', result);
    },
    setBatResultsToShow({commit}, result)
    {
        commit('SET_BAT_RESULTS', result);
    },
};

export const mutations = {
    SET_PLAN: (state, plan) =>
    {
        state.plan = plan;
    },
    SET_PLAN_COMPLETED: (state, isCompleted) =>
    {
        console.assert(state.plan, "Plan is not initialized but set plan completed is being called");
        if (state.plan) state.plan.is_completed = isCompleted;
    },
    SET_MUNICIPALITY: (state, municipalityFeature) =>
    {
        state.municipalityFeature = municipalityFeature;
    },
    SET_SST_RESULTS: (state, results) =>
    {
        state.results.sst = results;
    },
    SET_MHP_RESULTS: (state, results) =>
    {
        state.results.mhp = results;
    },
    SET_BAT_RESULTS: (state, results) =>
    {
        state.results.bat = results;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};

